__turbopack_context__.v({
  "footer": "_9zPxoW_footer",
  "social": "_9zPxoW_social",
});
